import { Reducer } from 'redux'
import { ICoursesState } from 'store/states/courses.state'
import { courseInitialState, ICourseNameList } from 'models/course.model'
import * as fromLessonsActions from '../actions/lessons-admin.action'
import * as fromActions from '../actions/courses.action'

export const initialState: ICoursesState = {
  section: '',
  list: [],
  total: 0,
  perPage: 0,
  sort: [],
  myList: [],
  mandatoryCourses: [],
  allCourses: [],
  course: {
    id: 0,
    ...courseInitialState,
    cardEnrolData: null,
  },
  courseProgress: [],
  courseToDuplicate: {},
  loading: true,
  loadingAll: true,
  loadingProgress: true,
  download: '',
  loadingCoursesToDuplicate: true,
  nameList: [] as ICourseNameList[],
  counters: { me: 0, all: 0 },
  folders: [],
  allFolders: [],
  sendEmail: false,
  dropdown: {
    downloadCourseDisabledUsersReport: {
      loading: false,
    },
  },
}

type Actions =
  | fromActions.CoursesDownloadDisabledUsersAction
  | {
      type: keyof typeof fromActions | keyof typeof fromLessonsActions
      payload: any
    }

export const reducer: Reducer<ICoursesState, Actions> = (
  state: ICoursesState = initialState,
  { type, payload }
) => {
  const { data } = payload || {}
  switch (type) {
    case fromActions.COURSES_SET_SECTION:
      return {
        ...state,
        section: payload,
      }
    case fromActions.COURSES_USER_GET_ALL_LIST:
      return {
        ...state,
        loadingAll: true,
      }
    case fromActions.COURSES_ADMINISTRATION_GET_LIST:
      return {
        ...state,
        loading: true,
      }
    case fromActions.COURSES_ADMINISTRATION_GET_LIST_SUCCESS: {
      const {
        data: coursesList,
        total: coursesTotal,
        perPage: coursesPerPage,
        sort: coursesSort,
      } = payload
      return {
        ...state,
        list: coursesList,
        total: coursesTotal,
        perPage: coursesPerPage,
        sort: coursesSort,
        loading: false,
      }
    }
    case fromActions.DESTROY_COURSE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.CREATE_COURSE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.SET_COURSE_LOADING: {
      const loading = typeof payload === 'boolean' ? payload : payload?.loading
      return {
        ...state,
        loading: !!loading,
      }
    }
    case fromActions.EDIT_COURSE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.COURSES_USER_GET_MY_LIST: {
      return {
        ...state,
        loadingAll: true,
      }
    }
    case fromActions.COURSES_USER_GET_MY_LIST_SUCCESS:
      return {
        ...state,
        myList: payload,
        loadingAll: false,
      }
    case fromActions.COURSES_USER_GET_MANDATORY_LIST_SUCCESS:
      return {
        ...state,
        mandatoryCourses: payload,
      }
    case fromActions.COURSES_USER_GET_ALL_LIST_SUCCESS:
      return {
        ...state,
        allCourses: payload,
        loadingAll: false,
      }
    case fromActions.GET_COURSE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.GET_COURSE_SUCCESS:
      return {
        ...state,
        course: payload,
        loading: false,
      }
    case fromActions.COURSES_USER_COURSE_PROGRESS:
      return {
        ...state,
        loadingProgress: true,
      }
    case fromActions.COURSES_USER_COURSE_PROGRESS_SUCCESS:
      return {
        ...state,
        courseProgress: payload,
        loadingProgress: false,
      }
    case fromLessonsActions.LESSONS_LIST_RELOAD:
      return {
        ...state,
        course: {
          ...state.course,
          lessons: payload,
        },
      }
    case fromActions.COURSES_DOWNLOAD:
      return {
        ...state,
        download: '',
        loading: true,
      }
    case fromActions.COURSES_DOWNLOAD_SUCCESS:
      return {
        ...state,
        download: payload,
        loading: false,
      }
    case fromActions.COURSES_DOWNLOAD_DISABLED_USERS: {
      const { dropdown } = state
      const { downloadCourseDisabledUsersReport } = dropdown
      return {
        ...state,
        dropdown: {
          ...dropdown,
          downloadCourseDisabledUsersReport: {
            ...downloadCourseDisabledUsersReport,
            loading: true,
          },
        },
      }
    }
    case fromActions.COURSES_DOWNLOAD_DISABLED_USERS_UPDATE: {
      const { loading } = payload
      const { dropdown } = state
      const { downloadCourseDisabledUsersReport } = dropdown
      return {
        ...state,
        dropdown: {
          ...dropdown,
          downloadCourseDisabledUsersReport: {
            ...downloadCourseDisabledUsersReport,
            loading,
          },
        },
      }
    }

    case fromActions.CLEAR_COURSES_DOWNLOAD:
      return {
        ...state,
        download: '',
      }
    case fromActions.GET_COURSE_DATA_TO_DUPLICATE:
      return {
        ...state,
        loadingCoursesToDuplicate: true,
      }
    case fromActions.GET_COURSE_DATA_TO_DUPLICATE_SUCCESS:
      return {
        ...state,
        courseToDuplicate: payload,
        loadingCoursesToDuplicate: false,
      }
    case fromActions.COURSE_DUPLICATE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.GET_ADMIN_COURSE:
      return {
        ...state,
        loading: true,
      }
    case fromActions.COURSES_GET_NAME_LIST:
      return {
        ...state,
        loading: true,
      }
    case fromActions.COURSES_GET_NAME_LIST_SUCCESS:
      return {
        ...state,
        nameList: payload,
        loading: false,
      }
    case fromActions.COURSES_GET_COUNTERS_SUCCESS:
      return {
        ...state,
        counters: payload,
      }
    case fromActions.COURSES_CLEAR_HOME_LISTS:
      return {
        ...state,
        myList: [],
        allCourses: [],
      }
    case fromActions.COURSES_SET_EMAIL_NOTIFICATION:
      return {
        ...state,
      }
    case fromActions.COURSES_GET_MY_FOLDERS:
      return {
        ...state,
        loading: true,
      }
    case fromActions.COURSES_GET_MY_FOLDERS_SUCCESS:
      return {
        ...state,
        folders: data,
        loading: false,
      }
    case fromActions.COURSES_GET_ALL_FOLDERS:
      return {
        ...state,
        loading: true,
      }
    case fromActions.COURSES_GET_ALL_FOLDERS_SUCCESS:
      return {
        ...state,
        allFolders: data,
        loading: false,
      }
    case fromActions.COURSES_REPORT:
      return {
        ...state,
        allFolders: data,
        loading: false,
      }
    case fromActions.COURSES_UPLOAD_MASSIVE_PARTICIPANTS:
      return {
        ...state,
        loading: true,
      }
    case fromActions.COURSES_UPLOAD_MASSIVE_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}
